var map = {
	"./25thanniversary.svg": "FAcS",
	"./go2partners23.svg": "B/U1",
	"./go2works.jpg": "PDjp",
	"./labMedia.svg": "u4w/",
	"./labMedia2.svg": "eOYK",
	"./managed.svg": "Cjs0",
	"./partners.svg": "3Exg",
	"./pmp.svg": "AMlW",
	"./printPromo.svg": "AyIb",
	"./prograde.svg": "nsa1",
	"./technology.svg": "OxNn",
	"./works.svg": "vQro"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ItGq";